<template>
	<div class="gb-header-schedule-list" :class="classHeaderScheduleList">
		<v-container class="primary gb-header-schedule-layout">
			<template v-if="!this.$store.getters.isEditable">
				<v-tabs v-model="toggle_display_list" v-on:change="onChangeDisplayList" color="primary" dark slider-color="white" height="55px">
					<v-tab :value="mode.PROJECT" active-class="gb-header-schedule-btn-disabled v-tabs__item--active" class="gb-header-schedule-tab-size">案件</v-tab>
					<v-tab :value="mode.MEMBER" active-class="gb-header-schedule-btn-disabled v-tabs__item--active" class="gb-header-schedule-tab-size">メンバー</v-tab>
				</v-tabs>
			</template>
			<template v-else>
				<v-tabs v-model="toggle_display_list" color="primary" dark slider-color="white" height="55px">
					<v-tab class="gb-header-schedule-btn-disabled gb-header-schedule-tab-size v-tabs__item--active">案件</v-tab>
					<v-tab class="grey--text gb-header-schedule-btn-disabled gb-header-schedule-tab-size v-tabs__item--active">メンバー</v-tab>
				</v-tabs>
				<v-btn flat absolute class="primary gb-header-schedule-add-btn" v-on:click="onClickShowProjectInfo">案件追加</v-btn>
			</template>
			<v-layout row>
				<v-flex xs4 class="d-flex justify-center">
					<v-btn flat class="primary white--text gb-header-schedule-btn-size"
						v-bind:disabled="!canShowMemberList"
						v-on:click="onClickShowMemberList"
					>メンバー</v-btn>
				</v-flex>
				<v-flex xs4 class="d-flex justify-center">
					<v-btn flat class="primary white--text gb-header-schedule-btn-size"
						v-bind:disabled="!canFilter"
						v-on:click="onClickShowScheduleFiltering"
					>フィルター</v-btn>
				</v-flex>
				<v-flex xs4 class="d-flex justify-center">
					<v-btn v-if="!this.$store.getters.isAllExpanded" flat class="primary white--text gb-header-schedule-btn-size" @click="onClickFolding">閉じる</v-btn>
					<v-btn v-if="this.$store.getters.isAllExpanded" flat class="primary white--text gb-header-schedule-btn-size" @click="onClickExpanding">開く</v-btn>
				</v-flex>
			</v-layout>
		</v-container>
		<div class="gb-header-schedule-title-date d-flex justify-center align-center" :style="styleScheduleTitleDate">日<br>付</div>
		<div v-if="showFreePerson" class="gb-header-schedule-title-free-person d-flex justify-center align-center">未</div>
	</div>
</template>
<script>
import { CALENDAR_TICK, PERMISSION, FORM_MODE } from '../data/Const';
import Project from '../data/Project';
import Notification from '../classes/Notification';
import { AdditinalData } from '../data/Project';

const MODE = {
	PROJECT: 0,
	MEMBER: 1,
};

const clonedeep = require('lodash/cloneDeep');

export default {
	name: 'GBHeaderScheduleList',
	props: [
		'narrow',
	],
	data () {
		return {
			toggle_display_list: this.$store.getters.displayListType,
			mode: MODE,
		}
	},
	methods: {
		onChangeDisplayList: function() {
			if (this.toggle_display_list === MODE.PROJECT){
				this.$store.dispatch('setDisplayListProject');
				this.$store.dispatch('toggleAllExpandProject');
			}else{
				this.$store.dispatch('setDisplayListMember');
				this.$store.dispatch('toggleAllExpandMember');
			}
		},
		onClickFolding: function() {
			if (this.toggle_display_list == MODE.PROJECT){
				this.$store.dispatch('foldingListProjectAll');
				this.$store.dispatch('toggleAllExpandProject');
			}else{
				this.$store.dispatch('foldingListMemberAll');
				this.$store.dispatch('toggleAllExpandMember');
			}
		},
		onClickExpanding: function() {
			if (this.toggle_display_list == MODE.PROJECT){
				this.$store.dispatch('expandingListProjectAll');
				this.$store.dispatch('toggleAllExpandProject');
			}else{
				this.$store.dispatch('expandingListMemberAll');
				this.$store.dispatch('toggleAllExpandMember');
			}
		},
		logout: function() {
			this.$store.dispatch('logout');
			this.$router.push({name: 'Login', params: { 'contractor_id': this.$route.params.contractor_id }});
		},
		emptyAdditionalData: function() {
			return this.$store.getters.additionalInfo.map(info => {
				return AdditinalData.createEmpty(info);
			});
		},
		
		onClickShowProjectInfo: function() {
			let project_list = Object.assign([], this.$store.getters.projectList);
			let project = Project.createEmpty();
			project.seq = Math.min(...project_list.map(p => p.seq), 1);
			project.project_additional = this.emptyAdditionalData();
			this.$store.dispatch('addListProject', project).then((res) => {
				if (res) {
					this.$emit('schedule-list-scroll-to', {project_code: project.code});
					this.$emit('update-dataset');
				} else {
					this.$store.commit('addNotification', Notification.error('案件追加に失敗しました', 'notificationCreateData'));
				}
			});
			this.$emit("show-project-info", {project: project, mode: FORM_MODE.ENTRY});
		},
		onClickShowMemberList: function() {
			this.$emit("show-member-list");
			this.$store.dispatch('setScheduleListFilteringAll');
		},
		onClickShowScheduleFiltering: function() {
			this.$emit("show-schedule-filtering", clonedeep(this.$store.getters.scheduleFilter));
		},
	},
	computed: {
		isCalendarTickWeek() {
			return this.$store.getters.calendarTick === CALENDAR_TICK.WEEK;
		},
		classHeaderScheduleList: function() {
			let classes = new Array();

			if (this.narrow)
				classes.push('narrow');

			return classes;
		},
		styleScheduleTitleDate() {
			let height = 67;

			if (!this.showFreePerson) {
				height += 22;
			}

			return {
				'height': height + 'px',
			};
		},
		canShowMemberList: function() {
			return this.$store.getters.hasPermission(PERMISSION.TYPE.ADMIN | PERMISSION.TYPE.VIEWER);
		},
		canFilter: function() {
			return this.$store.getters.hasPermission(PERMISSION.TYPE.ADMIN | PERMISSION.TYPE.VIEWER);
		},
		showFreePerson: function() {
			return !this.isCalendarTickWeek && this.$store.getters.hasPermission(PERMISSION.TYPE.ADMIN | PERMISSION.TYPE.VIEWER);
		},
	},
};
</script>
<style>
	.gb-header-schedule-list {
		flex: 0 0 300px !important;
		position: relative;
		border:solid 1px #DFDFDF;
		height: 89px;
		width: 300px;
		border-left: none;
	}
	.gb-header-schedule-list.narrow {
		flex: 0 0 244px !important;
		width: 244px;
	}
	.button-s{
		max-width: 30px !important;
	}
	.v-toolbar__content, .v-toolbar__extension{
		padding: 0px 10px;
	}
	
	.gb-header-schedule-layout {
		position: relative;
		padding: 0px 19px 0px 0px;
		height: 87px;
	}
	
	.gb-header-schedule-btn-size {
		font-size: 10px;
		min-width: 91px;
		height: 25px;
		margin: 3px 1px;
	}
	.narrow .gb-header-schedule-btn-size {
		min-width: 74px;
		padding: 0;
		margin: 3px 0px;
	}
	
	.gb-header-schedule-tab-size {
		width: 140px;
	}
	.narrow .gb-header-schedule-tab-size {
		width: 112px;
	}
	
	.gb-header-schedule-add-btn {
		font-size: 10px;
		padding: 2px 8px 0px 8px;
		height: 54px;
		width: 138px;
		top: 1px;
		right: 20px;
	}
	
	.gb-header-schedule-title-date, .gb-header-schedule-title-free-person {
		position: absolute;
		background-color: #e3f2fd;
		border:solid 1px #DFDFDF;
	}
	
	.gb-header-schedule-title-date {
		width: 20px;
		right: -1px;
		top: -1px;
	}
	
	.gb-header-schedule-title-free-person {
		height: 23px;
		width: 20px;
		right: -1px;
		top: 65px;
	}
	
	.gb-header-schedule-btn-disabled {
		box-shadow: none !important;
		pointer-events: none;
		cursor: default;
	}
</style>


